import { MyBooking, MyBookingEndPoint } from './myBooking.interfaces';
import { delay } from '@shared/utils/async';
import { HttpEndpoint } from '@/api/httpEndpoints';
import { MyBookingCredentials } from '@/api/MyBookingCredentials/myBookingCredentials.interfaces';
import { configBase } from '@/config/base';
import { fakeData } from './myBooking.fake';
import myBookingFakeJSON from '@/api/MyBooking/myBooking.fake.json';

const myBookingEndpoint = configBase.devMode.enabled
    ? 'mybooking'
    : 'https://booking-api.sembo.com/mybooking';

export class MyBookingEndpoint extends HttpEndpoint implements MyBookingEndPoint {
    public constructor(applicationUrl: string) {
        super(applicationUrl);
    }

    public async GetBooking(params: MyBookingCredentials): Promise<MyBooking> {
        const response = await this.get<MyBooking>(
            this.buildPathWithQuery(myBookingEndpoint, {
                'api-version': '1.0',
                boknid: params.id,
                id: params.password,
            }),

            {
                withCredentials: true,
                headers: {
                    sessionId: params.sessionId,
                    sessionData: params.sessionData,
                },
            }
        );

        return response;
    }
}

export class FakeMyBookingEndpoint implements MyBookingEndPoint {
    public async GetBooking(): Promise<MyBooking> {
        await delay(2000);

        const hasJSON = myBookingFakeJSON && Object.keys(myBookingFakeJSON).length > 0;

        if (hasJSON) {
            return myBookingFakeJSON as any;
        } else {
            return this.FilterResponse(fakeData as MyBooking);
        }
    }

    private FilterResponse(response: MyBooking): MyBooking {
        // const stored = getStoredFakeData();

        // if (stored && stored.enabled && stored.filter) {
        //     const { flight, ferry, hotel, golf, activity, transfer } =
        //         stored.filter;

        //     const filteredProducts: AnyBookingProduct[] = [];

        //     [...response.products]
        //         .filter((x) => {
        //             if (isMainProduct(x.type)) {
        //                 return (
        //                     (x.type === ProductType.Flight && flight.enabled) ||
        //                     (x.type === ProductType.Ferry && ferry.enabled) ||
        //                     (x.type === ProductType.Hotel && hotel.enabled) ||
        //                     (x.type === ProductType.Golf && golf.enabled) ||
        //                     (x.type === ProductType.Activity &&
        //                         activity.enabled) ||
        //                     (x.type === ProductType.Transfer &&
        //                         transfer.enabled)
        //                 );
        //             } else {
        //                 return x;
        //             }
        //         })
        //         .map((item) => filteredProducts.push(item));

        //     return {
        //         ...response,
        //         products:
        //             filteredProducts.length > 0
        //                 ? filteredProducts
        //                 : response.products,
        //     };
        // }

        return response;
    }
}
